import i18n from 'i18next';
import {IconButton, Tooltip, useDialog} from 'platform/components';
import {Show} from 'platform/foundation';

import {suffixTestId, TestIdProps} from 'shared/web';

import {SharePresetDialog} from './components/SharePresetDialog/SharePresetDialog';

export function SharePresetButton(props: TestIdProps) {
  const [isOpen, onOpen, onClose] = useDialog(false);

  return (
    <>
      <Tooltip label={i18n.t('page.datagrid.labels.sharePresetDialogTitle')}>
        <IconButton
          icon="social/share"
          onClick={onOpen}
          aria-label={i18n.t('page.datagrid.labels.sharePresetDialogTitle')}
          data-testid={suffixTestId('sharePreset', props)}
        />
      </Tooltip>
      <Show when={isOpen}>
        <SharePresetDialog onClose={onClose} data-testid={suffixTestId('sharePreset', props)} />
      </Show>
    </>
  );
}
